import { Html } from "@react-three/drei";


function LoadingSpinner() {
  return (
    <Html center>
    <div
      className="animate-spin inline-block w-12 h-12 lg:w-16 lg:h-16 border-[3px] border-current border-t-transparent rounded-full m-auto"
      role="status"
      aria-label="loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
    </Html>

  );
}

export default LoadingSpinner;
